import React from 'react';
import PropTypes from 'prop-types';

import SidePanelContainer from '../../common2/side-panel/SidePanelContainer';
import SidePanelContent from '../../common2/side-panel/SidePanelContent';
import SidePanelFooter from '../../common2/side-panel/SidePanelFooter';
import Column from '../../common/layout/Column';
import TakeActionPanelError from './TakeActionPanelError';
import { useTakeAction } from './useTakeAction';
import TakeActionForm from './TakeActionForm';
import TakeActionSubmitButton from './TakeActionSubmitButton';
import TakeActionPanelHeading from './TakeActionPanelHeading';
import DeclinedDateSection from './DeclinedDateSection';
import DeclinedReasonSection from './DeclinedReasonSection';
import SidePanelContentSection from '../../common2/side-panel/SidePanelContentSection';
import Locale from '../../Translate/Locale';
import { getDaysLeftToDispute } from './actionHelper';
import ExternalLink from '../../common2/links/ExternalLink';
import TakeActionDocuments from './TakeActionDocuments';

function DisputeDeclinedReasonPanel(props) {
  const { claim, onClose, onSubmitSuccess, customerResponse } = props;
  const { rejectedAt, isNon7sShipment } = claim;
  const { action, onChange, submit, isSubmitting, errors } = useTakeAction({
    claimId: claim.id,
    reason: customerResponse?.name,
    onSubmitSuccess,
  });

  const hasFiles = customerResponse?.files?.length > 0;

  return (
    <SidePanelContainer>
      <TakeActionPanelHeading onClose={onClose}>Declined</TakeActionPanelHeading>
      <SidePanelContent>
        <Column spacing="medium">
          {errors.form && <TakeActionPanelError>{errors.form}</TakeActionPanelError>}
          <DeclinedDateSection rejectedAt={claim.rejectedAt} />
          <DeclinedReasonSection customerResponse={customerResponse} />
          {!isNon7sShipment && (
            <SidePanelContentSection heading="Days remaining to dispute">
              {getDaysLeftToDispute(rejectedAt)}
            </SidePanelContentSection>
          )}
          <SidePanelContentSection heading="Dispute decline">
            <Locale>CLAIM_DECLINED_DISPUTE_MESSAGE</Locale>
          </SidePanelContentSection>
          {hasFiles && <TakeActionDocuments customerResponse={customerResponse} />}
          <TakeActionForm action={action} onChange={onChange} errors={errors} isSubmitting={isSubmitting} />
        </Column>
      </SidePanelContent>
      <SidePanelFooter>
        <TakeActionSubmitButton isLoading={isSubmitting} onClick={submit} />
      </SidePanelFooter>
    </SidePanelContainer>
  );
}

DisputeDeclinedReasonPanel.propTypes = {
  claim: PropTypes.shape({
    id: PropTypes.number,
    rejectedAt: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
};

export default React.memo(DisputeDeclinedReasonPanel);
